import axios from 'axios';
import url from './config/url';
function generateBatch(batchTypeId){
    console.log(batchTypeId);
    var config = {
        method: 'get',
        url:url +'generateBatchNumber',
        params:
        {
            batch_type_id:batchTypeId,
            //below two will be accessed from login data
            created_by_id:sessionStorage.getItem('by'),
            created_at_id:sessionStorage.getItem('at')
        }
        
    };

    return axios(config).then(response => {
        console.log(response);
        let res ={};
        if(response.data.status){
            console.log(response.data);
            console.log(response.data.successObject);
            res = {
                batchNumber:response.data.successObject,
                error:false
            }
            // this.setState({batchNumber:response.data.successObject});
           
        }
        else{
            res.error = true;
            res.errorDesc = response.data.errorDescription;
            // var errorDesc = ;
            // this.setState({errorVisible:true, errorDesc:response.data.errorDescription})
        }
        return res;
    }).catch(err=>{
        console.log(err);
    })
}

export default generateBatch;


// WEBPACK FOOTER //
// ./src/CommonFunc.js